export const TIMELINE_HEIGHT = 20;
export const TIMELINE_V_SPACE = 10;
export const LABEL_OFFSET = 5;
export const MARGIN = { top: 30, bottom: 45, right: 30 };
export const X_LINES_DIST = 100; // distance between x lines
export const LABEL_PANEL_WIDTH = 150;
